declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_spread_base2_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_fragile_demo_spread_base2_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_spread_base2 extends $mol_view {
		Head( ): $mol_view
		Body( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=base2.view.tree.d.ts.map